"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MenuAlignment;
(function (MenuAlignment) {
    MenuAlignment[MenuAlignment["TopCenter"] = 0] = "TopCenter";
    MenuAlignment[MenuAlignment["TopRight"] = 1] = "TopRight";
    MenuAlignment[MenuAlignment["RightCenter"] = 2] = "RightCenter";
    MenuAlignment[MenuAlignment["BottomRight"] = 3] = "BottomRight";
    MenuAlignment[MenuAlignment["BottomCenter"] = 4] = "BottomCenter";
    MenuAlignment[MenuAlignment["BottomLeft"] = 5] = "BottomLeft";
    MenuAlignment[MenuAlignment["LeftCenter"] = 6] = "LeftCenter";
    MenuAlignment[MenuAlignment["TopLeft"] = 7] = "TopLeft";
    MenuAlignment[MenuAlignment["RightTop"] = 8] = "RightTop";
    MenuAlignment[MenuAlignment["RightBottom"] = 9] = "RightBottom";
    MenuAlignment[MenuAlignment["LeftTop"] = 10] = "LeftTop";
    MenuAlignment[MenuAlignment["LeftBottom"] = 11] = "LeftBottom";
})(MenuAlignment || (MenuAlignment = {}));
exports.default = MenuAlignment;
//# sourceMappingURL=types.js.map